/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ActionQr from './ActionQr/index'
import Error from './Error/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2Launch from 'DesignSystem/Svgs/Tysiav2Launch/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function AppAction({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/Apps/Content/App/AppAction",
  onClick,
  onSubmit,
  disabled
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let launcherSubmitData = fromData.useDataSubmit({ viewPath,
context: 'launcher',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let launcherIconValueData = fromData.useDataValue({ viewPath,
context: 'launcher',
path: 'icon',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let launcherNameValueData = fromData.useDataValue({ viewPath,
context: 'launcher',
path: 'name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<button
  data-testid="AppAction.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onClick={launcherSubmitData}
 {...isHoveredBind}
 disabled={disabled}
 style={{'--mr-1-Z1ytLeI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-2-Z1ytLeI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-3-Z1ytLeI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-Z1ytLeI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-Z1ytLeI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-6-Z1ytLeI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-7-Z1ytLeI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-8-Z1ytLeI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-9-Z1ytLeI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-10-Z1ytLeI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-11-Z1ytLeI': isHovered ? dtColorsNeutral200 : dtColorsWhite,'--c-12-Z1ytLeI': disabled ? "default" : "pointer"}}
 className={`views-block ${styles.Horizontal}`}
>
<img
  data-testid="AppAction.Image"
  data-view-path={viewPath}
 alt={""}
 src={launcherIconValueData}
 style={{'--w-13-Z1ytLeI': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--h-14-Z1ytLeI': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Image}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="launcher.name"
 text={launcherNameValueData}
 size="xmedium"
 marginLeft={dtSpaceXs}
 color={disabled ? dtColorsNeutral500 : dtColorsNeutral900}
 data="launcher.error"
/>
<Error
  viewPath={`${viewPath}/Error`}
/>
<Tysiav2Launch
  viewPath={`${viewPath}/Tysiav2Launch`}
 marginLeft="auto"
 width={16}
 height={16}
 stroke={dtColorsNeutral500}
/>
</button>
<ActionQr
  viewPath={`${viewPath}/ActionQr`}
/>
{children}
</React.Fragment>)
}